import { Box, TextField, Typography } from '@mui/material';
import React from 'react';

interface UserDetailsFieldsProps {
  reporterName: string;
  reporterEmail: string;
  onNameChange: (val: string) => void;
  onEmailChange: (val: string) => void;
  disabled?: boolean;
}

export const UserDetailsFields: React.FC<UserDetailsFieldsProps> = ({
  reporterName,
  reporterEmail,
  onNameChange,
  onEmailChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
          Your name <span style={{ fontWeight: 400, color: '#6b7280' }}>(optional)</span>
        </Typography>
        <TextField
          size="small"
          fullWidth
          placeholder="Jane Doe"
          value={reporterName}
          onChange={(e) => onNameChange(e.target.value)}
          disabled={disabled}
          inputProps={{ style: { fontSize: '0.82rem' } }}
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
          Contact email <span style={{ fontWeight: 400, color: '#6b7280' }}>(optional)</span>
        </Typography>
        <TextField
          size="small"
          fullWidth
          type="email"
          placeholder="you@example.com"
          value={reporterEmail}
          onChange={(e) => onEmailChange(e.target.value)}
          disabled={disabled}
          inputProps={{ style: { fontSize: '0.82rem' } }}
        />
      </Box>
    </Box>
  );
};
